import React from "react";
import { type NextPage } from "next";
import { getLandingPageProps, getPageMetaImage, getSafeCustomer, type LandingPageProps } from "utils";
import { Page } from "components/page";
import {
  CampaignIntelligenceAccordion,
  CampaignIntelligenceHero,
  CampaignIntelligenceFeatures,
} from "components/platform/campaign-intelligence";
import { StackedLogos } from "components/logos";
import { sectionSpacingY } from "components/section";
import { CenteredQuote } from "components/quotes";
import { DestinationMarquee, ComposableCdpFeaturesPlate } from "components/content";
import { AuraPlate } from "ui/plates";

const CampaignIntelligence: NextPage<LandingPageProps> = ({
  page,
  announcementBanner,
  customers,
  destinations,
  defaultLogos,
}) => {
  const ramp = getSafeCustomer(customers, "ramp");

  return (
    <Page
      hasSmoothScroll
      title={page.metaTitle}
      description={page.metaDescription}
      image={getPageMetaImage({ src: page.metaImageUrl, alt: page.metaTitle })}
      announcementBanner={announcementBanner}
      theme="dark"
      bgColor="new.violet.950"
      footerOptions={{ variant: "violet" }}
    >
      <CampaignIntelligenceHero eyebrow={page.eyebrow} title={page.title} description={page.description} />

      <StackedLogos customers={defaultLogos} my={0} pt={{ base: "biggest", md: "huger" }} />

      <CampaignIntelligenceAccordion />

      <AuraPlate condensed variant="violet">
        <CenteredQuote
          maxW="780px"
          quoteText="This might be one of the greatest inventions for technical marketers since the advent of legacy CDPs back in 2015."
          author={{ name: "Austin Hay", job: "Head of Marketing Technology" }}
          company={{
            name: "Ramp",
            logo: ramp.logoUrl,
          }}
          cta={{ href: "/customers/ramp", text: "Read customer story" }}
        />
      </AuraPlate>

      <CampaignIntelligenceFeatures />

      <ComposableCdpFeaturesPlate
        title="Power more effective marketing with a Composable CDP"
        bgColor="new.violet.950"
        spotlightColor="new.violet.900"
        theme="dark"
      />

      <DestinationMarquee destinations={destinations} my={0} py={sectionSpacingY} />
    </Page>
  );
};

export const getStaticProps = getLandingPageProps("/platform/campaign-intelligence", {
  loadDefaultLogos: true,
  loadDestinations: "all",
  loadCustomers: ["ramp"],
});

export default CampaignIntelligence;
